<template>
  <div class="container">
    <h1>
      <b-icon icon="person-lines-fill"></b-icon> Profile
    </h1>
  
    <div class="row">
      <div class="col-md-3">
        <div class="panal mt-20">
       
   <div class="panal-body">
     <div class="text-center">

  <img v-if="currenUser.URLPathPhoto" :src="GetPic(currenUser.URLPathPhoto)" class="img-profile" alt="User image"/>
  <img v-else src="./../assets/user-profile.png" class="img-profile" alt="User image"/>
   <!-- <img rounded="circle"  :src="currenUser.ProfileImgUrl ? currenUser.ProfileImgUrl : '../img/user-profile.png'" alt="User image"
                            class="user-Iocn rounded circle" /> -->
  <!-- <div class="changeImg">
    <a href=""><b-icon icon="camera" font-scale="3"></b-icon></a>

  </div> -->
  <div class="mt-2">
     <h6>{{currenUser ? currenUser.FullNameEn : ''}} </h6>
    </div>
       <div class="mt-3 text-center">
 <b-button pill class="mr-2 mb-3" variant="success" @click="switchLogin = !switchLogin">Change User</b-button>
 <b-button pill class=" mb-3" variant="primary" v-b-modal.modal-center > Change Password <b-icon-lock-fill></b-icon-lock-fill></b-button>
 <!-- <b-dropdown pill right class="mb-3" split variant="primary" split-variant="outline-primary" text="Options">
      <b-dropdown-item  v-b-modal.modal-center>Change Password</b-dropdown-item>
      <b-dropdown-item @click.prevent="logOut">Logout</b-dropdown-item>
   
    </b-dropdown> -->
       </div>
     </div>

<div class="clearfix"></div>

</div>
        </div>
      </div>
  <div class="col-md-9">
  
    <div class="text-center" v-if="loadingData ">
                 <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div>
  <div class="panal mt-20" v-if="personalData.length > 0 & !isChangePassword">
        
   <div class="panal-body row">
<div class="col-md-3"><div class=" profileData">Full Name</div></div>
<div class="col-md-9"><div class=" profileData2">{{currenUser ? currenUser.FullNameEn : ''}}</div></div>
 <div class="clearfix mt-2"></div> 

 <div class="col-md-3 col-sm-12 mt-2"><div class=" profileData">University</div></div>
<div class="col-md-9 mt-2"><div class=" profileData2">{{personalData[0].UniversityName_EN}}</div></div>
 <div class="clearfix"></div> 

 

     <div class="col-md-3 col-sm-12 mt-2"><div class=" profileData">Student Code  </div></div>
<div class="col-md-9 col-sm-12 mt-2"><div class=" profileData2">{{personalData[0].StudentCode}}</div></div>
 <div class="clearfix"></div>  
 <div class="col-md-3 col-sm-12 mt-2"><div class=" profileData">Faculty Name</div></div>
<div class="col-md-9 col-sm-12 mt-2"><div class=" profileData2">{{currenUser.FacultyName_EN}}</div></div>
 <div class="clearfix"></div>        

<div class="col-md-3 col-sm-6 mt-2"><div class=" profileData">Email     </div></div>
<div class="col-md-9 col-sm-12 mt-2"><div class=" profileData2">{{currenUser.LoginInfo[0].Email ? currenUser.LoginInfo[0].Email : "--"}}</div></div>
 <div class="clearfix"></div> 


<div class="col-md-3 col-sm-12 mt-2"><div class=" profileData">National ID      </div></div>
<div class="col-md-9 col-sm-12 mt-2"><div class=" profileData2">{{personalData[0].NationID}}</div></div>
 <div class="clearfix"></div> 
<div class="col-md-3 col-sm-12 mt-2"><div class=" profileData">Nationality      </div></div>
<div class="col-md-9 col-sm-12 mt-2"><div class=" profileData2">{{personalData[0].CountryNameEN ?personalData[0].CountryNameEN : "--"}}</div></div>
 <div class="clearfix"></div> 


 <div class="col-md-3 col-sm-12 mt-2"><div class=" profileData">Address     </div></div>
<div class="col-md-9 col-sm-12 mt-2"><div class=" profileData2">{{personalData[0].Address ?personalData[0].Address : "--"}}</div></div>
 <div class="clearfix"></div> 

</div>
        </div>

    
          
           
            <div class="panal mt-20" v-if="isChangePassword" >
      
      <div class="panal-header2">  <h3>Thank You for confirming Your Account </h3> </div>
     <div class="panal-body">

                    <div ><div role="group">
                      
    <label for="input-live">Change Password:</label>
    <div class="row">

    
            <div class="col-md-6"><b-form-input
      id="input-live"
      v-model="newPassword"
      :state="nameState"
      aria-describedby="input-live-help input-live-feedback"
      placeholder="Enter your new password"
      trim
      type="password"
    ></b-form-input></div>          
            <div class="col-md-6">   <button class=" btn btn btn-primary " :disabled="!nameState" @click="changePassword">
                         
                          <span>Submit</span>
                        </button></div>          
    
                      </div>
                        
    <!-- This will only be shown if the preceding input has an invalid state -->
    <b-form-invalid-feedback id="input-live-feedback">
      Enter at least 5 charachters
    </b-form-invalid-feedback>

    <!-- This is a form text block (formerly known as help block) -->
    <b-form-text id="input-live-help"> Your password must be 8-20 characters long, contain letters and numbers, and must not
      contain spaces, special characters, or emoji..</b-form-text>
    <div v-if="Successmessage" class="alert alert-success" role="alert">{{Successmessage}}</div>
  </div> </div>
      </div>
     </div>
          


        <div class="panal mt-20" v-if="switchLogin">
        
   <div class="panal-body row">
<div class="col-md-10 mx-auto">
  <div class="row w-100">
<div class="col-md-3 col-sm-12 float-left title"><div class="img-user" :class="!currenUser.LoginInfo ? 'active2' : ''"><b-icon-person-plus-fill></b-icon-person-plus-fill></div> <div class="clearfix"></div><span class="" style="margin-left: 2.2rem !important;">Applicant</span> </div>
<div class="col-md-1 line1"></div>
<div class="col-md-3  col-sm-12 float-left  title"><div class="img-user" :class="currenUser.LoginInfo[0].RoleName == 'Student' ? 'active2' : ''"><b-icon-person-circle></b-icon-person-circle></div><div class="clearfix"></div><span class="" style="margin-left: 2.2rem !important;">Student</span>  </div>
<div class="col-md-1 line1 "></div>
<div class="col-md-2  col-sm-12 float-left  title"><div class="img-user" :class="currenUser.LoginInfo[0].RoleName != 'Student' ? 'active2' : ''"><b-icon-person-bounding-box></b-icon-person-bounding-box></div><div class="clearfix"></div><span class="" style="margin-left: 2.2rem !important;">Alumni </span> </div>

</div>

</div>

</div>
        </div>
      

      
      
     
      </div>
    </div>

   
    <b-modal id="modal-center" centered title="Confirm Your Data" ok-only ok-variant="secondary" ok-title="Cancel">
    
      <div class="col-md-9 mx-auto ">
                    <form name="form" @submit.prevent="handleLogin" @ok="ok" @hidden="ok" ref="formLogin">
                      <div class="form-group mt-40">

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              <font-awesome-icon icon="user" />
                            </div>
                          </div>
                          <input v-model="ApplicantData.Username" v-validate="'required'" type="text"
                            class="form-control" name="username" placeholder="Username" />
                        </div>
                        <div v-if="errors.has('username')" class="alert alert-danger" role="alert">Username is required!
                        </div>
                      </div>
                      <div class="form-group mt-20">
                        <div class="input-group">

                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              <font-awesome-icon icon="lock" />
                            </div>
                          </div>


                          <input v-model="ApplicantData.Password" v-validate="'required'" type="password"
                            class="form-control" name="password" placeholder="Password" />
                        </div>

                        <div v-if="errors.has('password')" class="alert alert-danger" role="alert">Password is required!
                        </div>
                      </div>
                      <div class="form-group mt-40">
                        <button class=" btn-block btn btn-outline-secondary" :disabled="loading">
                          <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                          <span>Verify</span>
                        </button>
                      </div>
                      <div class="form-group mt-40">
                          <button type="button" class="login-with-google-btn btn-block" @click="handleClickSignIn">
                            Sign in with Google
                          </button>
                      </div>
                   



                      <div class="form-group">
                        <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
                      </div>
                    </form>
                 
                  </div>
  </b-modal>
   
  </div>
</template>
<script>
import studentData from "../services/student/studentDataServices";
 
 
import {
    User
  } from '../models/user';
  import {
    ApplicantData
  } from '../models/Applicant'
import authServices from '../services/auth.service';


 
export default {
  name: "Profile",
  data() {
    return {
      personalData : [],
      switchLogin:false,
      user: new User('', ''),
        ApplicantData: new ApplicantData('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
          '', '', '', '',
          ''),
        loading: false,
        message: '',
        info:'',
        isInit : false ,
        isSignIn :false,
        isChangePassword : false,
        newPassword:'',
        isGmailLogin:false,
        Successmessage:'',
        loadingData : false
    };
  },
created(){
  let that = this;
    let checkGauthLoad = setInterval(function() {
      that.isInit = that.$gAuth.isInit;
      that.isSignIn = that.$gAuth.isAuthorized;
      if (that.isInit) clearInterval(checkGauthLoad);
    }, 1000);
},
  methods: {
            logOut() {
         this.$store.dispatch('auth/logout');
         this.$router.push('/login');
    },
    handleLogin() {
        this.loading = true;
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
            this.loading = false;
            return;
          }
          if (this.ApplicantData.Username && this.ApplicantData.Password) {
               //this.ApplicantData.Username = this.ApplicantData.Username + '@SU' 
           authServices.login(this.ApplicantData ).then(
              () => {
               // this.$router.push('/NewHome');
               //this.$alert('Data verify successfully')
               this.isChangePassword =true
               this.$bvModal.hide('modal-center')   
              
              },
              error => {
                this.loading = false;
                this.message =
                  (error.response && error.response.data && error.response.data.Message) ||
                  error.message ||
                  error.toString();
              }
            );
          }
        });
      },
     async handleClickSignIn() {
        // eslint-disable-next-line no-debugger
        debugger
   await   this.$gAuth
        .signIn()
        .then(GoogleUser => {
          //on success do something
         
          let userEmail
          // eslint-disable-next-line no-unused-vars
          Object.entries(GoogleUser.getBasicProfile()).forEach(([key, value]) => {
               // "a 5", "b 7", "c 9"
              if (value.includes('@su.edu.eg')){

                userEmail = value
              }
            });
          if(userEmail){
            // proceed to login
            this.$store.dispatch('auth/ExternalLogin', userEmail).then(
              () => {
                this.isChangePassword =true
               this.$bvModal.hide('modal-center')
               this.isGmailLogin = true
              },
              error => {
                this.loading = false;
                this.message =
                  (error.response && error.response.data && error.response.data.Message) ||
                  error.message ||
                  error.toString();
              }
            );
          }else{
           // eslint-disable-next-line no-unused-vars
           const responseT =   this.$gAuth.signOut();
           this.message = "Please use university email to login"
          }
         
          //this.isSignIn = this.$gAuth.isAuthorized;
        })
        .catch(error => {
          //on fail do something
        console.log('error',error)
        });
    },
    changePassword(){
      
        authServices.ChangePassword(this.currenUser.LoginInfo[0].username ,this.isGmailLogin ? '' : this.ApplicantData.Password,this.newPassword).then((res)=>{
          this.Successmessage = res.data
          setTimeout(()=>{this.logOut()},5000)
          
        },
                error => {
                  this.loading = false;
                  this.Successmessage =
                    (error.response && error.response.data && error.response.data.Message) ||
                    error.message ||
                    error.toString();
                })
      

      
      },
      ok(){
        this.$refs.formLogin.reset()
      },
      GetPic(path){
        return "http://unicodesis.su.edu.eg:90"+path
      }
  },

  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
    nameState() {
        return this.newPassword.length > 5 ? true : false
      }
  },

  mounted() {
    this.loadingData = true
    studentData.GetStudentData(this.currenUser.StudentID).then(
      (Response) => {
        this.isLoading = false;
        this.loadingData = false
        this.personalData = Response.data.StudentData;
        // eslint-disable-next-line no-console
       //  console.log(this.personalData);

      },
      (error) => {
        // eslint-disable-next-line no-console
        // console.log(error.response.status);

        this.message =
          (error.response &&
            error.response.data &&
            error.response.data.Message) ||
          error.message ||
          error.toString();

        if (error.response.status == 404) this.message = "";
      }
    )
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.img-profile{
   border-radius: 50%;
   width:180px;
   border:2px solid #285475;
}

.img-user {
      border-radius: 50%;
    width: 100px;
    height: 100px;
    border: 2px dotted #ff8600;
    background: #f2f2f2;
    text-align: center;
    vertical-align: middle;
    padding: 21px;
    float: left;
    margin: 10px;
    font-size: 34px;
}

.active2 {
   background: #285475 !important;
   color:#fff;
}
.title{
  color:#285475;
  font-weight: 700;
text-align: left;
}
.changeImg{
  margin-top: -40px;
    position: absolute;
    left: 180px;
}
.changeImg a{
  color:#ff8600;
}
.profileData{
  border: 1px dotted #646464;
  color:#285475;
  padding: 3px 10px;
  font-weight: 700;
}

.profileData2{
  border: 1px dotted #646464;
  color:#ff8600;
  padding: 3px 10px;
  font-weight: 700;
}
.clearfix{
 clear: both;
  display: table;
}
.line1{
     border-top: 1px dotted #285475;
    border-bottom: 1px dotted #285475;
    height: 10px;
   
    float: left;
   margin: 57px 20px;
}


@media screen and (max-width: 1024px) {
 .line1{
    display: none;
}
}

@media screen and (max-width: 1180px) and (min-width: 750px)  {
.img-profile{
   border-radius: 50%;
   width:100px;
   border:2px solid #285475;
}
}

.login-with-google-btn {
  transition: background-color 0.3s, box-shadow 0.3s;
  padding: 12px 16px 12px 42px;
  border: none;
  border-radius: 3px;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);
  color: #757575;
  font-size: 14px;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=);
  background-color: white;
  background-repeat: no-repeat;
  background-position: 12px 11px;
}
.login-with-google-btn:hover {
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25);
}
.login-with-google-btn:active {
  background-color: #eeeeee;
}
.login-with-google-btn:focus {
  outline: none;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25), 0 0 0 3px #c8dafc;
}
.login-with-google-btn:disabled {
  filter: grayscale(100%);
  background-color: #ebebeb;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.panal-header2 {
  background: #346faf;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}
</style>
